export default {
  hero_label: 'CONTACT',
  hero_title: 'お問い合わせ',
  hero_desc: 'AI戦略の立案・DX推進・AI人材育成など、AIを活用した事業変革のご相談は\nAIX JAPANにお任せください。まずはお気軽にご連絡ください。',
  what_label: 'WHAT WE CAN HELP',
  what_title: 'こんなご相談に対応しています',
  help_1_title: 'AI戦略の立案',
  help_1_desc: '自社にとって最適なAI活用戦略を一から設計。現状分析からロードマップ策定まで一貫してご支援します。',
  help_2_title: 'DX推進・実行支援',
  help_2_desc: '戦略策定だけで終わらせず、実装・運用まで伴走。組織が自走できる体制づくりを共に実現します。',
  help_3_title: 'AI導入・業務改革',
  help_3_desc: '業務プロセスへのAI組み込みによる生産性向上と、社内変革を推進するチェンジマネジメントを支援します。',
  help_4_title: 'データ活用・分析基盤',
  help_4_desc: '蓄積されたデータを経営・事業の意思決定に活かすための分析基盤構築と活用推進をご提供します。',
  form_label: 'INQUIRY FORM',
  form_title: 'ご相談・お問い合わせフォーム',
  form_select_label: 'お問い合わせ区分をお選びください',
  inquiry_service_label: '事業・サービスに関するお問い合わせ',
  inquiry_service_desc: 'AI戦略・DX推進・システム開発など',
  inquiry_recruit_label: '採用エントリー',
  inquiry_recruit_desc: '募集職種へのご応募・キャリア相談',
  form_company: '会社名',
  form_company_ph: '例：株式会社〇〇',
  form_name: 'お名前',
  form_name_ph: '例：山田 太郎',
  form_email: 'メールアドレス',
  form_email_ph: '例：yamada@company.co.jp',
  form_phone: '電話番号',
  form_phone_ph: '例：03-0000-0000',
  form_services: 'ご興味のあるサービス',
  form_selected: '選択中',
  form_message: 'お問い合わせ内容',
  form_message_ph: 'AIの活用に関するご相談、DX推進のご要望など、お気軽にご記入ください。',
  form_chars: '文字',
  form_submit: '送信する',
  form_submitting: '送信中...',
  form_submit_note: '送信後、3営業日以内に担当者よりご連絡いたします。',
  form_success: 'お問い合わせを受け付けました。担当者より3営業日以内にご連絡させていただきます。',
  form_error: '送信に失敗しました。入力内容をご確認の上、再度お試しください。',
  err_name_required: 'お名前を入力してください',
  err_company_required: '会社名を入力してください',
  err_email_invalid: 'メールアドレスの形式が正しくありません',
  err_message_required: 'お問い合わせ内容を入力してください',
  err_message_length: '500文字以内で入力してください',
  err_email_required: 'メールアドレスを入力してください',
  err_position_required: '応募職種を選択してください',
  err_pr_required: '自己PR・志望動機を入力してください',
  err_pr_length: '500文字以内で入力してください',
  recruit_banner: '採用エントリーフォームです。書類選考後、担当者より面接日程についてご連絡いたします。まずはお気軽にエントリーください。',
  form_position: '応募職種',
  form_employment_type: '希望雇用形態',
  employment_types: ['正社員', 'フリーランス', '契約社員', 'インターン'],
  form_affiliation: '現職・所属',
  form_affiliation_note: '（現在の会社・学校名など）',
  form_affiliation_ph: '例：株式会社〇〇 / 〇〇大学',
  form_pr: '自己PR・志望動機',
  form_pr_ph: 'これまでの経験・スキル、AIX JAPANへの志望動機をご記入ください。',
  form_entry: 'エントリーする',
  form_entry_note: '書類選考の結果は1週間以内にご連絡いたします。',
  recruit_success_title: 'エントリーを受け付けました',
  recruit_success: '書類選考の結果は1週間以内にご登録のメールアドレスへご連絡いたします。',
};